// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UmJtu{-moz-appearance:textfield}.UmJtu::-webkit-inner-spin-button,.UmJtu::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}`, "",{"version":3,"sources":["webpack://./src/components/pagination/Pagination.module.scss"],"names":[],"mappings":"AAAA,OACE,yBAAA,CAGF,oEAEE,uBAAA,CACA,QAAA","sourcesContent":[".input {\n  -moz-appearance: textfield;\n}\n\n.input::-webkit-inner-spin-button,\n.input::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `UmJtu`
};
export default ___CSS_LOADER_EXPORT___;
